import { Button, Menu, MenuButton, MenuList } from '@chakra-ui/react'
import { FC } from 'react'

import useTools from '@hook/shared/use-tools'

import { ILayoutToolsActionExport } from '@base/@types/components/Layout/Tools'

import ActionExcelAlertFollowUpExport from './alert/Excel-followUp'
import ActionExcelAlertFollowUpCommentExport from './alert/Excel-followUpComment'
import ActionExcelAlertFollowUpReabExport from './alert/Excel-followUpReab'
import ActionExcelAlertFollowUpReabCommentExport from './alert/Excel-followUpReabComment'
import ActionExcelAlertPurchaseExport from './alert/Excel-purchase'
import ActionExcelAlertaPurchaseExport from './alert/Excel-Purchase-Process'
import ActionExcelCommercialAnalitcExport from './budget/Excel-Commercial-Analitc'
import ActionExcelCommercialConsolidatedExport from './budget/Excel-Commercial-Consolidated'
import ActionExcelConciliationAnalitcExport from './budget/Excel-Conciliation-Analitc'
import ActionExcelConciliationConsolidatedExport from './budget/Excel-Conciliation-Consolidated'
import ActionExcelReportAnalitcExport from './budget/Excel-Report-Analitc'
import ActionExcelReportConsolidatedExport from './budget/Excel-Report-Consolidated'
import ActionExcelStoreAnalitycExport from './budget/Excel-Store-Analityc'
import ActionExcelStoreConsolidatedExport from './budget/Excel-Store-Consolidated'
import ActionExcelExport from './Excel'
import ActionExcelBackExport from './Excel-Back'
import ExcelLogisticKpi from './kpi/ExcelLogisticKpi'
import ExcelRuptureKpi from './kpi/ExcelRuptureKpi'
import ExcelSalesKpi from './kpi/ExcelSalesKpi'
import ExcelStorangeKpi from './kpi/ExcelStorangeKpi'
import ActionExcelDistributionMroExport from './mrp/Excel-Distribution'
import ActionExcelPurshaseProgramedExport from './mrp/Excel-PurshaseProgramed'
import ActionExcelReabMroExport from './mrp/Excel-Reab'
import ActionDistribuitonMrpSAPExport from './mrp/SAP-Distribution'
import ActionDistribuitonMrpFormatadaSAPExport from './mrp/SAP-Distribution-Formtada'
import ActionSAPPurshaseProgramedExport from './mrp/SAP-PurshaseProgramed'
import ActionSapReabMrpExport from './mrp/SAP-Reab'
import ActionExcelFollowUpOtbExport from './otb/Excel-FollowUp'
import ActionExcelCurveDepedentsCDExport from './parametrization/Excel-CurveDepedentsCD'
import ActionExcelCurveExecutationExport from './parametrization/Excel-CurveExecutation'
import ActionExcelCurveNewStoreExport from './parametrization/Excel-CurveStore'
import ActionExcelCurveWeightExport from './parametrization/Excel-CurveWeight'
import ActionExcelIncrementSupplyParameterExport from './parametrization/Excel-IncrementSupplier'
import ActionExcelMininumBillingParameterExport from './parametrization/Excel-MinimumBilling'
import ActionExcelPurchaseAlcadasExport from './parametrization/Excel-PurchaseAlcadas'
import ActionExcelPurchaseCronogramaExport from './parametrization/Excel-PurchaseCronograma'
import ActionExcelPurchaseFeriasExport from './parametrization/Excel-PurchaseFerias'
import ActionExcelPurchaseToleranciaExport from './parametrization/Excel-PurchaseTolerancia'
import ActionExcelPurchaseUserExport from './parametrization/Excel-PurchaseUser'
import ActionExcelReabCronograaExport from './parametrization/Excel-ReabCronogramaOne'
import ActionExcelReabRouteExport from './parametrization/Excel-ReabRoutes'
import ActionExcelReabTypeVeichuleExport from './parametrization/Excel-ReabTypeVeichule'
import ActionExcelRevisionParameterExport from './parametrization/Excel-Revision'
import ActionExcelSimilarProductParameterExport from './parametrization/Excel-SimilarProduct'
import ActionExcelSupplyParameterExport from './parametrization/Excel-Supply'
import ActionModeloTabelasPurchaseUserExport from './parametrization/ModeloTabelas-PurchaseUser'
import ActionSAPExport from './SAP'
const ActionExport: FC<ILayoutToolsActionExport> = ({ exports: rows }) => {
  const { isDisabled } = useTools()

  return (
    <Menu size="sm">
      <MenuButton
        as={Button}
        size="xs"
        fontSize="12px"
        fontWeight="normal"
        letterSpacing=".2px"
        p="4px 6px"
        // loading={rows[0].loading}
        isDisabled={isDisabled}
        bg="gray.200"
        rounded={5}
        _hover={{ bgColor: 'gray.100' }}
        _active={{ bgColor: 'gray.100' }}
      >
        Exportar
      </MenuButton>
      <MenuList zIndex={4} bgColor="white">
        {rows.map((row, rowIdx) => {
          if (row.type === 'excel' && row.entity === 'salesKpi') {
            return (
              <ExcelSalesKpi
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'storangeKpi') {
            return (
              <ExcelStorangeKpi
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'logisticKpi') {
            return (
              <ExcelLogisticKpi
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'ruptureKpi') {
            return (
              <ExcelRuptureKpi
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'purshaseProgramedMrp') {
            return (
              <ActionExcelPurshaseProgramedExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'ReabMrp') {
            return (
              <ActionExcelReabMroExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'DistributionMrp') {
            return (
              <ActionExcelDistributionMroExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'PurchaseAlert') {
            return (
              <ActionExcelAlertaPurchaseExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'budgetReportAnalitc') {
            return (
              <ActionExcelReportAnalitcExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'budgetCommercialConsolidated'
          ) {
            return (
              <ActionExcelCommercialConsolidatedExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'budgetCommercialAnalitc'
          ) {
            return (
              <ActionExcelCommercialAnalitcExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'budgetReportConsolidated'
          ) {
            return (
              <ActionExcelReportConsolidatedExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'budgetConciliationConsolidated'
          ) {
            return (
              <ActionExcelConciliationConsolidatedExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'budgetConciliationAnalitc'
          ) {
            return (
              <ActionExcelConciliationAnalitcExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'budgetStoreAnalitc') {
            return (
              <ActionExcelStoreAnalitycExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'budgetStoreConsolidated'
          ) {
            return (
              <ActionExcelStoreConsolidatedExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'alertPurchase') {
            return (
              <ActionExcelAlertPurchaseExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'alertFollowUp') {
            return (
              <ActionExcelAlertFollowUpExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'alertFollowUpComment') {
            return (
              <ActionExcelAlertFollowUpCommentExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'alertFollowUpReabComment'
          ) {
            return (
              <ActionExcelAlertFollowUpReabCommentExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'alertFollowUpReab') {
            return (
              <ActionExcelAlertFollowUpReabExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'otbFollowUp') {
            return (
              <ActionExcelFollowUpOtbExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'purshaseMrp') {
            return (
              <ActionExcelBackExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'parameterSupply') {
            return (
              <ActionExcelSupplyParameterExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'parameterRevision') {
            return (
              <ActionExcelRevisionParameterExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'parameterSimilarProduct'
          ) {
            return (
              <ActionExcelSimilarProductParameterExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'parameterIncrementProduct'
          ) {
            return (
              <ActionExcelIncrementSupplyParameterExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'parameterCurveWeight') {
            return (
              <ActionExcelCurveWeightExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'parameterCurveStore') {
            return (
              <ActionExcelCurveNewStoreExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'parameterCurveExecutation'
          ) {
            return (
              <ActionExcelCurveExecutationExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'parameterCurveDepedentsCD'
          ) {
            return (
              <ActionExcelCurveDepedentsCDExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'parameterReabRoutes') {
            return (
              <ActionExcelReabRouteExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'paramasReabTimeline') {
            return (
              <ActionExcelReabCronograaExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'parameterReabTypeVeichule'
          ) {
            return (
              <ActionExcelReabTypeVeichuleExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (
            row.type === 'excel' &&
            row.entity === 'parameterMinimumBilling'
          ) {
            return (
              <ActionExcelMininumBillingParameterExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }
          if (row.type === 'excel' && row.entity === 'cronogramaCompra') {
            return (
              <ActionExcelPurchaseCronogramaExport
                key={`actions-${row.type}-export`}
                data={row.data}
              />
            )
          }
          if (row.type === 'csv' && row.entity === 'purchaseUserData') {
            return (
              <ActionExcelPurchaseUserExport
                key={`actions-${row.type}-data-export`}
              />
            )
          }
          if (
            row.type === 'csv' &&
            row.entity === 'purchaseUserModeloTabelas'
          ) {
            return (
              <ActionModeloTabelasPurchaseUserExport
                key={`actions-${row.type}-modelo-tabelas-export`}
              />
            )
          }
          if (row.type === 'csv' && row.entity === 'purchaseFeriasData') {
            return (
              <ActionExcelPurchaseFeriasExport
                key={`actions-${row.type}-ferias-export`}
              />
            )
          }
          if (row.type === 'csv' && row.entity === 'purchaseAlcadasData') {
            return (
              <ActionExcelPurchaseAlcadasExport
                key={`actions-${row.type}-alcadas-export`}
              />
            )
          }
          if (row.type === 'csv' && row.entity === 'purchaseToleranciaData') {
            return (
              <ActionExcelPurchaseToleranciaExport
                key={`actions-${row.type}-tolerancia-export`}
              />
            )
          }
          if (row.type === 'excel') {
            return (
              <ActionExcelExport
                key={`actions-${rowIdx}-${row.type}-export`}
                headers={row.headers!}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          }

          if (row.type === 'sap' && row.entity === 'purshaseProgramedMrp') {
            return (
              <ActionSAPPurshaseProgramedExport
                key={`actions-${rowIdx}-${row.type}-export`}
                data={row.data}
                sapModal={row.sapModal}
              />
            )
          } else if (row.type === 'sap' && row.entity === 'ReabMrp') {
            return (
              <ActionSapReabMrpExport
                key={`actions-${rowIdx}-${row.type}-export`}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          } else if (row.type === 'sap' && row.entity === 'DistributionMrp') {
            return (
              <ActionDistribuitonMrpSAPExport
                key={`actions-${rowIdx}-${row.type}-export`}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          } else if (
            row.type === 'sap' &&
            row.entity === 'DistributionMrpFormatada'
          ) {
            return (
              <ActionDistribuitonMrpFormatadaSAPExport
                key={`actions-${rowIdx}-${row.type}-export`}
                data={row.data}
                parser={row.parser}
                onClick={row.onClick}
              />
            )
          } else {
            return (
              <ActionSAPExport
                key={`actions-${rowIdx}-${row.type}-export`}
                data={row.data}
                sapModal={row.sapModal}
              />
            )
          }
        })}
      </MenuList>
    </Menu>
  )
}

export default ActionExport
